import * as React from "react";
const SvgUsers = (props) => /* @__PURE__ */ React.createElement("svg", {
	width: 36,
	height: 36,
	viewBox: "0 0 36 36",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props
}, /* @__PURE__ */ React.createElement("rect", {
	width: 36,
	height: 36,
	rx: 8,
	fill: "#E8FAEB"
}), /* @__PURE__ */ React.createElement("path", {
	fillRule: "evenodd",
	clipRule: "evenodd",
	d: "M17.5 14.5C17.5 16.43 19.07 18 21 18C22.93 18 24.5 16.43 24.5 14.5C24.5 12.57 22.93 11 21 11C19.07 11 17.5 12.57 17.5 14.5ZM19.5 14.5C19.5 13.67 20.17 13 21 13C21.83 13 22.5 13.67 22.5 14.5C22.5 15.33 21.83 16 21 16C20.17 16 19.5 15.33 19.5 14.5ZM21 19.75C23.34 19.75 28 20.92 28 23.25V25H14V23.25C14 20.92 18.66 19.75 21 19.75ZM21 21.75C22.79 21.75 24.82 22.42 25.66 23H16.34C17.18 22.42 19.21 21.75 21 21.75ZM13.96 19.81C12.8 20.65 12 21.77 12 23.25V25H8V23.25C8 21.23 11.5 20.08 13.96 19.81ZM11.5 14.5C11.5 16.43 13.07 18 15 18C15.54 18 16.04 17.87 16.5 17.65C15.87 16.76 15.5 15.67 15.5 14.5C15.5 13.33 15.87 12.24 16.5 11.35C16.04 11.13 15.54 11 15 11C13.07 11 11.5 12.57 11.5 14.5Z",
	fill: "#26CD58"
}));
export default SvgUsers;
